import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Collapse,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import Select from "react-select";
import { getRegisterFieldDataUsingCategoryId, getRegisterFieldDataUsingJobCategoryId, submitAllRegisterFieldData, submitFilterData } from "model/CategoryModel";
import Spinners from "components/Common/Spinner";
import { pascalToCamel } from "helpers/GeneralHelper";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { toast } from "react-toastify";
import * as Yup from "yup";



const RegisterField = () => {
  const fieldschema = Yup.array().of(
    Yup.object().shape({
      name: Yup.string()
        .trim()
        .required("Field Group Name is required"),

      fields: Yup.array().of(
        Yup.object().shape({
          name: Yup.string()
            .trim()
            .required("Register Field Name is required"),
        })
      ),
    })
  );

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const [sections, setSections] = useState([]
    //   [
    //   { id: 1, name: "Driver Information", fields: [], sort: 0, status: 'active' },
    //   { id: 2, name: "Driver Schedule", fields: [], sort: 1, status: 'active' },
    //   { id: 3, name: "Benefits", fields: [], sort: 2, status: 'active' },
    //   {
    //     id: 4,
    //     name: "Miscellaneous",
    //     fields: [
    //       {
    //         id: 1,
    //         fieldType: "text",
    //         name: "Trucks (Can you describe your fleet in brief)",
    //         sort: 0,
    //         status: 'active'
    //       },
    //       {
    //         id: 2,
    //         fieldType: "text",
    //         name:
    //           "Additional Information (Please let us know if there is any other information that you would like to share.)",
    //         sort: 1,
    //         status: 'active'
    //       },
    //       {
    //         id: 2,
    //         fieldType: "text",
    //         name:
    //           "Additional Information",
    //         sort: 2,
    //         status: 'active'
    //       },
    //     ],
    //   },
    //   { id: 5, name: "User Account", fields: [], sort: 3, status: 'active' },
    //   { id: 6, name: "First Advantage login details", fields: [], sort: 4, status: 'active' },
    // ]
  );

  const [openSection, setOpenSection] = useState(null);
  const [updatedSections, setUpdatedSections] = useState([]);
  const [jobCategoryData, setJobCategoryData] = useState("");
  const [loading, setLoading] = useState(false);
  const [jobCategoryId, setJobCategoryId] = useState("");
  const [errors, setErrors] = useState({});




  // Open first section
  useEffect(() => {
    if (sections.length > 0 && openSection === null) {
      setOpenSection(0);
    }
  }, []);

  const toggleSection = (index) => {
    setOpenSection(openSection === index ? null : index);
  };

  const handleDeleteSection = (sectionIndex) => {
    const updated = sections.filter((_, i) => i !== sectionIndex);
    setSections(updated);
  };

  const handleAddField = (sectionIndex) => {
    const updated = sections.map((section, i) => {
      if (i === sectionIndex) {
        const newField = {
          id: "-1",
          name: "",
          fieldType: "text",
          status: "active",
          sort: sectionIndex
        };
        return { ...section, fields: [...section.fields, newField] };
      }
      return section;
    });
    setSections(updated);
  };

  const handleDeleteField = (sectionIndex, fieldIndex) => {
    const updated = sections.map((section, i) => {
      if (i === sectionIndex) {
        const newfields = section.fields.filter((_, fi) => fi !== fieldIndex);
        return {
          ...section,
          fields:
            newfields.length === 0
              ? [
                {
                  id: "-1",
                  name: "Enter Register Label",
                  fieldType: "text",
                },
              ]
              : newfields,
        };
      }
      return section;
    });

    setSections(updated);
  };

  // const handleFieldChange = (sectionIndex, fieldIndex, name) => {
  //   const updated = sections.map((section, i) => {
  //     if (i === sectionIndex) {
  //       return {
  //         ...section,
  //         fields: section.fields.map((field, fi) =>
  //           fi === fieldIndex ? { ...field, name } : field
  //         ),
  //       };
  //     }
  //     return section;
  //   });

  //   setSections(updated);
  //   markSectionUpdated(sectionIndex);
  // };

  // const handleRegisterGroupNameChange = (sectionIndex, name) => {
  //   const updated = sections.map((section, i) =>
  //     i === sectionIndex ? { ...section, name: name } : section
  //   );

  //   setSections(updated);
  //   markSectionUpdated(sectionIndex);
  // };


  const handleFieldChange = (sectionIndex, fieldIndex, value) => {
    const updated = sections.map((section, i) => {
      if (i === sectionIndex) {
        return {
          ...section,
          fields: section.fields.map((field, fi) =>
            fi === fieldIndex
              ? { ...field, name: value }
              : field
          ),
        };
      }
      return section;
    });

    setSections(updated);

    // Validate on change
    validateSingleField(
      `[${sectionIndex}].fields[${fieldIndex}].name`,
      value
    );
  };

  const handleRegisterGroupNameChange = (sectionIndex, value) => {
    const updated = sections.map((section, i) =>
      i === sectionIndex
        ? { ...section, name: value }
        : section
    );

    setSections(updated);

    // Validate on change
    validateSingleField(
      `[${sectionIndex}].name`,
      value
    );
  };

  const validateSingleField = async (path, value) => {
    try {
      await Yup.reach(fieldschema, path).validate(value);

      // remove error if valid
      setErrors((prev) => {
        const updated = { ...prev };
        delete updated[path];
        return updated;
      });

    } catch (err) {
      setErrors((prev) => ({
        ...prev,
        [path]: err.message,
      }));
    }
  };





  const markSectionUpdated = (sectionIndex) => {
    if (!updatedSections.includes(sectionIndex)) {
      setUpdatedSections([...updatedSections, sectionIndex]);
    }
  };

  const handleSaveAll = async () => {
    try {
      setErrors({}); // reset errors

      await fieldschema.validate(sections, {
        abortEarly: false,
      });

      let response = await submitAllRegisterFieldData(sections);

      if (response?.success) {
        toast.success(response?.message);
        jobCategoryItem(jobCategoryId);
      } else {
        toast.error(response?.message);
      }

    } catch (validationError) {
      const formattedErrors = {};

      validationError.inner.forEach((err) => {
        formattedErrors[err.path] = err.message;
      });

      setErrors(formattedErrors);
    }
  };



  // Ensure each section has at least one field
  useEffect(() => {
    const updated = sections.map((section) => {
      if (!section.fields || section.fields.length === 0) {
        return {
          ...section,
          fields: [
            {
              id: "-1",
              name: "Enter Register Label",
              fieldType: "text",
              status: "active",
              sort: section?.fields?.length
            },
          ],
        };
      }
      return section;
    });
    setSections(updated);
  }, []);

  const getJobCategoryList = async () => {
    setLoading(true);
    let response = await submitFilterData({});
    let categoryData = response?.data;
    const valueReModified = categoryData?.map(item => ({
      ...item,
      label: item?.name,
      value: item?.id
    }));
    if (response) {
      setJobCategoryData(valueReModified);
      setLoading(false);
    } else {
      setJobCategoryData([]);
      setLoading(false);
    }
  };

  const jobCategoryItem = async (jobCategoryId) => {
    setJobCategoryId(jobCategoryId)
    const payload = {
      jobCategoryId: jobCategoryId,
    };
    let response = await getRegisterFieldDataUsingJobCategoryId(payload);
    let registerFieldData = response?.data;
    if (response) {
      setSections(registerFieldData);
    } else {
      setSections([]);
    }

    setLoading(false);
  }

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const { source, destination, type } = result;
    if (type === "SECTION") {
      const reordered = Array.from(sections);
      const [removed] = reordered.splice(source.index, 1);
      reordered.splice(destination.index, 0, removed);

      const updated = reordered.map((item, index) => ({
        ...item,
        sort: index,
      }));

      setSections(updated);
    }
    if (type === "FIELD") {
      const sectionIndex = parseInt(source.droppableId.split("-")[1]);

      const updatedSections = [...sections];
      const currentFields = [...updatedSections[sectionIndex].fields];

      const [movedItem] = currentFields.splice(source.index, 1);
      currentFields.splice(destination.index, 0, movedItem);

      const reorderedFields = currentFields.map((field, idx) => ({
        ...field,
        sort: idx,
      }));

      updatedSections[sectionIndex].fields = reorderedFields;

      setSections(updatedSections);
    }

  };

  const handleAddSection = () => {
    const newSection = {
      id: "-1",
      name: "",
      jobCategoryId: jobCategoryId,
      fields: [
        {
          id: "-1",
          name: "",
          fieldType: "text",
          sort: 0,
          status: "active",
        },
      ],
      sort: sections?.length,
      status: "active",
    };

    setSections((prev) => {
      const updated = [...prev, newSection];
      return updated.map((section, index) => ({
        ...section,
        sort: index,
      }));
    });

    setOpenSection(sections.length);
  };


  useEffect(() => {
    getJobCategoryList();
  }, []);



  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Card className="shadow-sm border-0">
            <CardBody className={`${(jobCategoryId && jobCategoryData?.length && sections?.length) ? '' : 'card-body-90-vh'} `}>
              <h5 className="fw-bold mb-0 pe-2">Register Field</h5>
              <hr />
              <Row>
                <Col sm={`${(jobCategoryId && jobCategoryData?.length && sections?.length) ? 6 : 12}`} className={`${(jobCategoryId && jobCategoryData?.length && sections?.length)? '' : 'd-flex justify-content-center'}`}>

                  {(!loading && jobCategoryData?.length) ?
                    <Select
                      options={jobCategoryData}
                      className={`select2-selection ${(jobCategoryId && jobCategoryData?.length && sections?.length) ? '' : 'select2-selection-width'}`}
                      onChange={(e) => jobCategoryItem(e?.id)}
                      placeholder="Select Job Category"
                    /> : <Spinners setLoading={setLoading} />
                  }
                </Col>
                {(jobCategoryId && jobCategoryData?.length && sections?.length) ?
                  <Col sm={6}>
                    <div className="text-center d-flex justify-content-end gap-3">
                      <Button color="primary" onClick={handleSaveAll} className="border-radius-none"
                      >
                        Update
                      </Button>
                    </div>
                  </Col> : null
                }
              </Row>

              {/* <Row>
                <Col sm={`${(jobCategoryId && jobCategoryData?.length && sections?.length) ? 12 : 12}`}>

                  {(!loading && jobCategoryData?.length) ?
                    <Select
                      options={jobCategoryData}
                      className="select2-selection"
                      onChange={(e) => jobCategoryItem(e?.jobCategoryId)}
                      placeholder="Select Job Category"
                    /> : <Spinners setLoading={setLoading} />
                  }
                </Col>
                {(jobCategoryId && jobCategoryData?.length && sections?.length) ?
                  <Col sm={12} className="mt-2">
                    <div className="text-center d-flex justify-content-end gap-3">
                      <Button color="primary" onClick={handleSaveAll} className="border-radius-none"
                      >
                        Update
                      </Button>
                    </div>
                  </Col> : null
                }
              </Row> */}

              <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="sections-droppable" type="SECTION">
                  {(provided) => (
                    <div ref={provided.innerRef} {...provided.droppableProps}>

                      {sections
                        ?.sort((a, b) => a?.sort - b?.sort)
                        .map((section, sectionIndex) => (
                          <Draggable
                            key={sectionIndex}
                            draggableId={`section-${sectionIndex}`}
                            index={sectionIndex}
                          >
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                className="field-section mt-2 blue-border"
                              >
                                <div
                                  {...provided.dragHandleProps}
                                  className="field-section-header d-flex justify-content-between align-items-center"
                                  onClick={() => toggleSection(sectionIndex)}
                                >
                                  <span className="fw-semibold">
                                    {section.name}
                                  </span>
                                  <div className="d-flex align-items-center gap-2">
                                    <Button
                                      color="link"
                                      className="icon-btn text-danger p-0"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleDeleteSection(sectionIndex);
                                      }}
                                    >
                                      <i className="fa fa-trash fs-6"></i>
                                    </Button>
                                    <i
                                      className={`fa ${openSection === sectionIndex
                                        ? "fa-chevron-up"
                                        : "fa-chevron-right"
                                        } text-primary fs-6`}
                                    ></i>
                                  </div>
                                </div>
                                <Collapse isOpen={openSection === sectionIndex}>
                                  <div className="field-section-body p-3 mt-0">
                                    <FormGroup>
                                      <Label className="fw-bold">Field Group <span className="text-danger">*</span></Label>
                                      <Input
                                        type="text"
                                        value={section.name}
                                        onChange={(e) =>
                                          handleRegisterGroupNameChange(
                                            sectionIndex,
                                            e.target.value
                                          )
                                        }
                                        className="mb-3"
                                        placeholder="Enter Register Group"
                                      />
                                    </FormGroup>
                                    {errors[`[${sectionIndex}].name`] && (
                                      <p className="text-danger small mt-2">
                                        {errors[`[${sectionIndex}].name`]}
                                      </p>
                                    )}
                                    <div className="register-field-box">
                                      <div className="fw-bold mb-3"><span className="ml-15">Register Field <span className="text-danger">*</span></span></div>

                                      <Droppable
                                        droppableId={`fields-${sectionIndex}`}
                                        type="FIELD"
                                      >
                                        {(provided) => (
                                          <div
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                          >
                                            {section?.fields?.map(
                                              (field, index) => (
                                                <Draggable
                                                  key={index}
                                                  draggableId={`field-${sectionIndex}-${index}`}
                                                  index={index}
                                                >
                                                  {(provided) => (
                                                    <div
                                                      ref={provided.innerRef}
                                                      {...provided.draggableProps}
                                                      className="mb-2"
                                                    >
                                                      <div className="d-flex align-items-start">
                                                        <span {...provided.dragHandleProps}>
                                                          <i className="fa fa-grip-vertical pe-2 cursor-grab cursor-grab-pos"></i>
                                                        </span>
                                                        <div className="flex-grow-1 me-2">
                                                          <Input
                                                            type={field.fieldType}
                                                            placeholder={"Enter Register Field"}
                                                            value={field.name}
                                                            onChange={(e) =>
                                                              handleFieldChange(
                                                                sectionIndex,
                                                                index,
                                                                e?.target?.value
                                                              )
                                                            }
                                                            invalid={
                                                              !!errors[
                                                              `[${sectionIndex}].fields[${index}].name`
                                                              ]
                                                            }
                                                          />
                                                          {errors[
                                                            `[${sectionIndex}].fields[${index}].name`
                                                          ] && (
                                                              <span className="text-danger small mt-4">
                                                                {
                                                                  errors[
                                                                  `[${sectionIndex}].fields[${index}].name`
                                                                  ]
                                                                }
                                                              </span>
                                                            )}
                                                        </div>
                                                        <i
                                                          className="fa fa-trash text-danger mt-2"
                                                          onClick={() =>
                                                            handleDeleteField(sectionIndex, index)
                                                          }
                                                        ></i>
                                                      </div>
                                                    </div>
                                                  )}
                                                </Draggable>
                                              )
                                            )}

                                            {provided.placeholder}
                                          </div>
                                        )}
                                      </Droppable>

                                      <Button
                                        color="primary"
                                        size="sm"
                                        className="border-radius-none ml-15"
                                        onClick={() => handleAddField(sectionIndex)}
                                      >
                                        + Add Field
                                      </Button>

                                    </div>
                                  </div>
                                </Collapse>

                              </div>
                            )}
                          </Draggable>
                        ))}

                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
              {(!sections?.length || !jobCategoryId) &&
                <div className="text-center mt-4 d-flex justify-content-center gap-3">
                <h6 className="text-sm font-weight-bold">{(!sections?.length && jobCategoryId) ? `No Data Found` : `You Have To Select Job Category For Further Progress`}</h6> 
                </div>
              }
              {(jobCategoryId && jobCategoryData?.length) &&
                <>
                  <div className="text-center mt-4 d-flex justify-content-center gap-3">
                    <Button color="primary" onClick={handleAddSection} className="border-radius-none"
                    >
                      + Add Section
                    </Button>
                  </div>

                </>
              }
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default RegisterField;
